import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EChartsOption } from 'echarts';
import { NumberSuffixPipe } from 'src/app/core/filters/numberSuffix-pipe';
import { LowerBound } from 'src/app/core/services/lowerBound.service';
import { ChartService } from 'src/app/core/services/waterfallChart.service';

@Component({
  selector: 'app-customer-sales-realization-chart',
  templateUrl: './customer-sales-realization-chart.component.html',
  styleUrls: ['./customer-sales-realization-chart.component.scss'],
})
export class CustomerSalesRealizationChartComponent implements OnInit {
  @Input() salesReal: any = {};
  @Input() source: 'nrp' | 'cssna' = 'nrp';

  chartOption: EChartsOption = {};
  data: any[] = [];
  positive: any = [];
  negative: any = [];
  sales_data: any = [];

  min: number = 0;
  max: number = 0;
  start: any = [];
  reduce: number = 0;
  startingPoint: number = 0;
  base: number = 0;
  graphData: any[] = [];
  scaleBreak = true;
  private waterfallRows: any[][] = [];
  constructor(private chart: ChartService, private lowerBound: LowerBound) { }

  ngOnInit(): void {
    let data: any[] = [];

    data[0] = this.salesReal.prior_period_sales;
    data[1] = this.salesReal.price;
    data[2] = this.salesReal.mix_sales;
    data[3] = this.salesReal.volume_sales;
    data[4] = this.salesReal.acquisition_sales;
    data[5] = this.salesReal.attrition_sales;
    data[6] = this.salesReal.forex_sales;
    data[7] = this.salesReal.current_period_sales;
    this.data = data;
    this.base = 0;
    const waterfallData = [
      [
        'barLabel',
        'barStartValue',
        'barEndValue',
        'referenceDatapoint',
        'index',
      ],

      ['2025', this.base, this.data[0], 2, 0],

      ['Price', this.data[0], this.data[0] + this.data[1]],

      [
        'Mix',
        this.data[0] + this.data[1],
        this.data[0] + this.data[1] + this.data[2],
      ],
      [
        'Volume',
        this.data[0] + this.data[1] + this.data[2],
        this.data[0] + this.data[1] + this.data[2] + this.data[3],
      ],
      [
        'Acquisition',
        this.data[0] + this.data[1] + this.data[2] + this.data[3],
        this.data[0] +
        this.data[1] +
        this.data[2] +
        this.data[3] +
        this.data[4],
      ],
      [
        'Attrition',
        this.data[0] + 
        this.data[1] + 
        this.data[2] + 
        this.data[3] + 
        this.data[4],
        this.data[0] +
        this.data[1] +
        this.data[2] +
        this.data[3] +
        this.data[4] +
        this.data[5],
      ],
      [
        'FX',
        this.data[0] + 
        this.data[1] + 
        this.data[2] + 
        this.data[3] + 
        this.data[4] +
        this.data[5],
        this.data[0] +
        this.data[1] +
        this.data[2] +
        this.data[3] +
        this.data[4] +
        this.data[5] +
        this.data[6],
      ],

      ['2026', this.base, this.data[7], 2, 0],
    ];

    this.waterfallRows = waterfallData;
    this.renderChart();
  }

  onScaleBreakToggle(enabled: boolean): void {
    this.scaleBreak = enabled;
    this.renderChart();
  }

  private renderChart(): void {
    const prepared = this.lowerBound.prepareSalesWaterfall(
      this.waterfallRows,
      this.scaleBreak
    );
    this.startingPoint = prepared.startingPoint;
    this.base = prepared.startingPoint;
    this.chartOption = this.chart.loadWaterFall(
      prepared.data,
      prepared.startingPoint,
      'YOY Sales Realization',
      undefined,
      this.scaleBreak ? 2 : 1
    );
  }

}
